import { NUMBER_BY_LINE, RATIO } from '@/const/gallery'

export function generateGalleryState(matrix: any[], length: number) {
  let index = 0
  let row = 1
  let column = 1
  let currentLine = 0

  const state: any = {
    totalLines: 0,
    itemsPositions: [],
    lines: [],
  }

  while (index < length) {
    let line: any = {}

    switch (matrix[currentLine]) {
      case NUMBER_BY_LINE.ONE_PER_LINE:
        line = {
          column: '1/13',
          row: `${row}/${row + 1}`,
          type: 'one-per-line',
          format: 'portrait',
          lineNumber: row,
          columnStart: column,
          index,
        }

        currentLine += 1
        row += 1
        state.totalLines += 1
        state.lines.push({
          number: 1,
          ratio: RATIO.PORTRAIT,
        })
        break

      case NUMBER_BY_LINE.ONE_PER_LINE_LANDSCAPE:
        line = {
          column: '1/13',
          row: `${row}/${row + 1}`,
          type: 'one-per-line',
          format: 'landscape',
          lineNumber: row,
          columnStart: column,
          index,
        }

        currentLine += 1
        row += 1
        state.totalLines += 1
        state.lines.push({
          number: 1,
          ratio: RATIO.LANDSCAPE,
        })
        break

      case NUMBER_BY_LINE.TWO_PER_LINE:
        if (column === 1 && index === length - 1) {
          line = {
            column: '1/13',
            row: `${row}/${row + 1}`,
            type: 'one-per-line',
            format: 'portrait',
            lineNumber: row,
            columnStart: column,
            index,
          }

          column = 1
          row += 1
          currentLine += 1
          state.totalLines += 1
          state.lines.push({ number: 1, ratio: RATIO.PORTRAIT })
          break
        } else {
          line = {
            column: `${column}/${column + 6}`,
            row: `${row}/${row + 1}`,
            type: 'two-per-line',
            format: 'portrait',
            lineNumber: row,
            columnStart: column,
            index,
          }
        }

        if (column > 6) {
          column = 1
          row += 1
          currentLine += 1
          state.totalLines += 1
          state.lines.push({ number: 2, ratio: RATIO.PORTRAIT })
        } else {
          column += 6
        }
        break

      case NUMBER_BY_LINE.THREE_PER_LINE:
        if (column === 1 && index === length - 1) {
          line = {
            column: `1/13`,
            row: `${row}/${row + 1}`,
            type: 'one-per-line',
            format: 'portrait',
            lineNumber: row,
            columnStart: column,
            index,
          }
          column = 1
          row += 1
          currentLine += 1
          state.totalLines += 1
          state.lines.push({ number: 1, ratio: RATIO.PORTRAIT })
          break
        } else if (column === 1 && index === length - 2) {
          line = {
            column: `1/7`,
            row: `${row}/${row + 1}`,
            type: 'two-per-line',
            format: 'portrait',
            lineNumber: row,
            columnStart: column,
            index,
          }
        } else if (column === 5 && index === length - 1) {
          line = {
            column: `7/13`,
            row: `${row}/${row + 1}`,
            type: 'two-per-line',
            format: 'portrait',
            lineNumber: row,
            columnStart: column,
            index,
          }

          column = 1
          row += 1
          currentLine += 1
          state.totalLines += 1
          state.lines.push({ number: 2, ratio: RATIO.PORTRAIT })
          break
        } else {
          line = {
            ...line,
            column: `${column}/${column + 4}`,
            row: `${row}/${row + 1}`,
            type: 'three-per-line',
            format: 'portrait',
            lineNumber: row,
            columnStart: column,
            index,
          }
        }

        if (column > 8) {
          column = 1
          row += 1
          currentLine += 1
          state.totalLines += 1
          state.lines.push({ number: 3, ratio: RATIO.PORTRAIT })
        } else {
          column += 4
        }
        break

      case NUMBER_BY_LINE.ONE_LINE_PORTRAIT_LANDSCAPE:
        line = {
          column:
            column === 1
              ? `${column}/${column + 4}`
              : `${column}/${column + 8}`,
          row: `${row}/${row + 1}`,
          type: 'two-per-line',
          format: column === 1 ? 'portrait' : 'landscape',
          lineNumber: row,
          columnStart: column,
          index,
        }

        if (column > 4) {
          column = 1
          row += 1
          currentLine += 1
          state.totalLines += 1
          state.lines.push({ number: 3, ratio: RATIO.PORTRAIT })
        } else {
          column += 4
        }
        break

      case NUMBER_BY_LINE.ONE_LINE_LANDSCAPE_PORTRAIT:
        line = {
          column:
            column === 1
              ? `${column}/${column + 8}`
              : `${column}/${column + 4}`,
          row: `${row}/${row + 1}`,
          type: 'two-per-line',
          format: column === 1 ? 'landscape' : 'portrait',
          lineNumber: row,
          columnStart: column,
          index,
        }

        if (column > 8) {
          column = 1
          row += 1
          currentLine += 1
          state.totalLines += 1
          state.lines.push({ number: 3, ratio: RATIO.PORTRAIT })
        } else {
          column += 8
        }
        break
    }

    state.itemsPositions.push(line)

    if (currentLine >= matrix.length) {
      currentLine = 0
    }

    index++
  }

  return state
}
